import {  useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import CarrierePage from "pages/audit retraite/carriere";

const RetraitePage = (props) => {
const context = useContext(AppContext);
  return (
    <>
      {/* <Column fill> */}
     <CarrierePage ClientConjoint=""/>
{context.state.InclureConjoint && <CarrierePage ClientConjoint="Conjoint" />}
        {/* {context.state.InclureConjoint && (
          <Row>
            <Column fill>
              <CardBox tpad>
                <Column fill>
                  <Row>
                    <h1>Carrière {context.state.PrenomConjoint}</h1>
                  </Row>
                  <Row center>
                    <Column>
                      <Button
                        onClick={() => {
                          setClientConjoint("Conjoint");
                          setmodalRISRetr(true);
                        }}
                      >
                        <span>Importer le RIS pour {context.state.PrenomConjoint}</span>
                        <FaUpload />
                      </Button>
                    </Column>
                    <Column>
                      <Button
                        onClick={() => {
                          setClientConjoint("Conjoint");
                          context.handleResetPeriodeRetraite("Conjoint","");
                          setmodalPeriodeRetr(true);
                        }}
                      >
                        <span>Ajouter une période pour {context.state.PrenomConjoint}</span>
                        <FaPlusCircle />
                      </Button>
                    </Column>

                    <Column>
                      <Button
                        onClick={() => {
                          setClientConjoint("Conjoint");
                          setmodalParamRetrOpen(true);
                        }}
                      >
                        <span>Paramétrer la retraite pour {context.state.PrenomConjoint}</span>
                        <FaCogs id="paramRetraiteConjoint" />
                      </Button>
                    </Column>
                  </Row>
                  <Row tpad>
                    <table>
                      <thead>
                        <tr>
                          <th>Date de début</th>
                          <th>Date de fin</th>
                          <th>Activité</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {context.state.CarriereConjoint.map((Infos, Index) => {
                          return (
                            <tr key={"Conj" + Index}>
                              <td>{applyFormat(Infos.Debut, "date", "")}</td>
                              <td>{applyFormat(Infos.Fin, "date", "")}</td>
                              <td>{CorrespondanceActivite[Infos.Nature]}</td>
                              <td>
                                <Button
                                  onClick={() => {
                                    setClientConjoint("Conjoint");
                                    context.handleModifyDeletePeriodeRetraite(Infos.id, "Modifier", "", "Conjoint");
                                    setmodalPeriodeRetr(true);
                                  }}
                                  icon
                                  style={{ display: "inline-block" }}
                                >
                                  <FaEdit />
                                </Button>
                                {Infos.id !== "CarriereActuelle" && (
                                  <Button
                                    onClick={() => {
                                      setClientConjoint("Conjoint");
                                      Dialogs.confirm("Vous êtes sur le point de supprimer la période.\nVoulez-vous continuer ?", "Suppression de la période", () => {
                                        context.handleModifyDeletePeriodeRetraite(Infos.id, "Supprimer", "", "Conjoint");
                                      });
                                    }}
                                    icon
                                    style={{ display: "inline-block" }}
                                  >
                                    <FaTrashAlt className="delete" />
                                  </Button>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </Row>
                  <Row tpad>
                    <table>
                      <thead>
                        <tr>
                          <th colSpan={2}>Synthèse de la retraite pour {context.state.PrenomConjoint}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style={{ width: "50%" }}>Trimestres retenus</td>
                          <td>{context.state.TotalTrimestreConjoint}</td>
                        </tr>
                        <tr>
                          <td>Age de départ en retraite</td>
                          <td>
                            <Row>
                              <Column style={{ padding: 0 }}>{context.state.AgeDepartRetraiteConjoint}</Column>
                              <Column style={{ padding: 0, alignSelf: "flex-end", marginTop: "0px" }}>
                                <Button
                                  icon
                                  style={{ display: "inline-block" }}
                                  onClick={() => {
                                    setClientConjoint("Conjoint");
                                    setmodalParamRetrOpen(true);
                                  }}
                                >
                                  <FaEdit />
                                </Button>
                              </Column>
                              <Column style={{ padding: 0, alignSelf: "flex-end", marginTop: "0px" }}>
                                <Button
                                  icon
                                  style={{ display: "inline-block", color: "red" }}
                                  onClick={() => {
                                    setClientConjoint("Conjoint");
                                    setmodalParamRetrOpen(true);
                                  }}
                                >
                                </Button>
                              </Column>
                            </Row>
                          </td>
                        </tr>
                        <tr>
                          <td>Date de départ en retraite</td>
                          <td>{context.state.DateDepartRetraiteAffichageConjoint}</td>
                        </tr>
                      </tbody>
                    </table>
                  </Row>
                </Column>
              </CardBox>
            </Column>
          </Row>
        )} */}
      {/* </Column> */}

     
    </>
  );
};

export default RetraitePage;
